// ─── Quel compte l'écran de connexion vise-t-il ? ────────────────────────
//
// LE DÉFAUT, TROUVÉ LE 2026-08-02. Sur le staging du cockpit, la connexion
// répondait « Mot de passe incorrect » quel que soit le mot de passe saisi.
// Le mot de passe n'y était pour rien : l'écran envoie `anissa.nutri@gmail.com`,
// une adresse qui n'existe **que** dans la base de production. La base de
// staging ne contient qu'un seul compte, `praticienne@example.invalid`.
//
// Supabase répond « Invalid login credentials » aussi bien pour un mot de
// passe faux que pour une adresse inconnue — c'est volontaire, ça empêche de
// deviner qui possède un compte. Mais du coup l'écran affichait un message
// qui accusait le mot de passe, et rien ne pouvait mettre sur la piste.
//
// CE N'EST PAS UNE PROTECTION, et il ne faut pas le lire comme tel. Viser le
// mauvais compte ne donne aucun accès : c'est la base qui tranche, pas cette
// table. Elle évite seulement de saisir un mot de passe pour une adresse qui
// n'existe pas dans la base qu'on a en face.

/** Le compte synthétique du staging. Aucune personne réelle derrière. */
export const COMPTE_STAGING = 'praticienne@example.invalid';

/** Les comptes de production. */
export const COMPTES_PRODUCTION = Object.freeze({
  Benoit: 'benfitcoach.geneve@gmail.com',
  Anissa: 'anissa.nutri@gmail.com',
});

/** `VITE_ENVIRONNEMENT` est la variable d'AFFICHAGE, absente en production. */
export function enStaging(env) {
  return String(env?.VITE_ENVIRONNEMENT ?? '').trim().toLowerCase() === 'staging';
}

/**
 * L'adresse à laquelle se connecter pour cet utilisateur, dans cet
 * environnement.
 *
 * En staging, **tous** les utilisateurs mènent au compte synthétique : c'est
 * le seul qui existe dans cette base, et `est_praticien_saas()` n'y reconnaît
 * que lui. Proposer un autre choix ne ferait que produire un refus de plus.
 *
 * @returns {string|null} l'adresse, ou `null` si l'utilisateur est inconnu
 */
export function adressePourConnexion(utilisateur, env) {
  if (enStaging(env)) return COMPTE_STAGING;
  return COMPTES_PRODUCTION[utilisateur] ?? null;
}
